import {
  AccordionDetails,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { formatInput } from 'src/util/STR';

const DuringSiteQulificationVisit: React.FunctionComponent<any> = ({
  durationSiteVisitUpdate,
  sqChecklistPILFormData,
  setSqChecklistPILFormData,
  setIsNavigateToPannel,
  checkedInStartDate
}) => {
  const { duringTheSiteQualificationVisit } = useFieldTranslation();
  const dispatch = useDispatch();
  const [isSaveBtnEnable, setIsSaveBtnEnable] = React.useState(false);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_sq_checklist_pil');

  const handleCheckBox = (e: any) => {
    const data = e.target.checked ? true : false;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: data });
    setConfirmExitValue(dispatch, true);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };

  const handleCheck = (e: any) => {
    const data = e.target.value;
    const formattedVal = typeof data === 'string' ? formatInput(data) : data;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: formattedVal });
    setConfirmExitValue(dispatch, true);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };
 

  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checkbox-block">
        <Grid spacing={3} container className="date-block">
          <Grid item md={12}>
            <b>{duringTheSiteQualificationVisit.header1}:</b>
          </Grid>
          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label1}</Typography>}
                  value={sqChecklistPILFormData.sq_exam_room}
                  name="sq_exam_room"
                  checked={sqChecklistPILFormData.sq_exam_room === true ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label2}</Typography>}
                  value={sqChecklistPILFormData.sq_lab_area}
                  name="sq_lab_area"
                  checked={sqChecklistPILFormData.sq_lab_area ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label13}</Typography>}
                  value={sqChecklistPILFormData.sq_special_testing}
                  name="sq_special_testing"
                  checked={sqChecklistPILFormData.sq_special_testing ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label4}</Typography>}
                  value={sqChecklistPILFormData.sq_pharmacy}
                  name="sq_pharmacy"
                  checked={sqChecklistPILFormData.sq_pharmacy ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label5}</Typography>}
                  value={sqChecklistPILFormData.sq_hospital_unit}
                  name="sq_hospital_unit"
                  checked={sqChecklistPILFormData.sq_hospital_unit ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label6}</Typography>}
                  value={sqChecklistPILFormData.sq_work_area}
                  name="sq_work_area"
                  checked={sqChecklistPILFormData.sq_work_area ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label8}</Typography>}
                  value={sqChecklistPILFormData.sq_storage_area_ip}
                  name="sq_storage_area_ip"
                  checked={sqChecklistPILFormData.sq_storage_area_ip ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label9}</Typography>}
                  value={sqChecklistPILFormData.sq_storage_area_supplies}
                  name="sq_storage_area_supplies"
                  checked={sqChecklistPILFormData.sq_storage_area_supplies ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_sponsor_tour_comm"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_sponsor_tour_comm || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!isDisable || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <Grid md={6}>
              <b>{duringTheSiteQualificationVisit.header2}:</b>
            </Grid>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label10}</Typography>}
                  value={sqChecklistPILFormData.sq_storage_area_supplies}
                  name="sq_discuss_protocol_rev"
                  checked={sqChecklistPILFormData.sq_discuss_protocol_rev ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label11}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_protocol_modification}
                  name="sq_discuss_protocol_modification"
                  checked={sqChecklistPILFormData.sq_discuss_protocol_modification ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label12}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_lab}
                  name="sq_discuss_lab"
                  checked={sqChecklistPILFormData.sq_discuss_lab ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label13}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_special_proc}
                  name="sq_discuss_special_proc"
                  checked={sqChecklistPILFormData.sq_discuss_special_proc ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label14}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_data_entry}
                  name="sq_discuss_data_entry"
                  checked={sqChecklistPILFormData.sq_discuss_data_entry ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label15}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_storage}
                  name="sq_discuss_storage"
                  checked={sqChecklistPILFormData.sq_discuss_storage ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label16}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_ip_benefit}
                  name="sq_discuss_ip_benefit"
                  checked={sqChecklistPILFormData.sq_discuss_ip_benefit ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label17}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_publication_policy}
                  name="sq_discuss_publication_policy"
                  checked={sqChecklistPILFormData.sq_discuss_publication_policy ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label18}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_personnel}
                  name="sq_discuss_personnel"
                  checked={sqChecklistPILFormData.sq_discuss_personnel ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label19}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_training}
                  name="sq_discuss_training"
                  checked={sqChecklistPILFormData.sq_discuss_training ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label20}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_irb_time}
                  name="sq_discuss_irb_time"
                  checked={sqChecklistPILFormData.sq_discuss_irb_time ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label21}</Typography>}
                  value={sqChecklistPILFormData.sq_discuss_contract_time}
                  name="sq_discuss_contract_time"
                  checked={sqChecklistPILFormData.sq_discuss_contract_time ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_discuss_comment"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_discuss_comment || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!isDisable || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <Grid item md={14}>
              <b>{duringTheSiteQualificationVisit.header3}:</b>
            </Grid>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label22}</Typography>}
                  value={sqChecklistPILFormData.sq_over_sponsor_responsibilities}
                  name="sq_over_sponsor_responsibilities"
                  checked={sqChecklistPILFormData.sq_over_sponsor_responsibilities ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label23}</Typography>}
                  value={sqChecklistPILFormData.sq_over_monitoring_plan}
                  name="sq_over_monitoring_plan"
                  checked={sqChecklistPILFormData.sq_over_monitoring_plan ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label24}</Typography>}
                  value={sqChecklistPILFormData.sq_over_data_management}
                  name="sq_over_data_management"
                  checked={sqChecklistPILFormData.sq_over_data_management ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label25}</Typography>}
                  value={sqChecklistPILFormData.sq_over_timelines}
                  name="sq_over_timelines"
                  checked={sqChecklistPILFormData.sq_over_timelines ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label26}:</Typography>}
                  value={sqChecklistPILFormData.sq_over_key_dates}
                  name="sq_over_key_dates"
                  checked={sqChecklistPILFormData.sq_over_key_dates ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid>
            <Grid item md={12}>
              <ul className="ULinsideAccordion" style={{ fontSize: '16px' }}>
                <li>{duringTheSiteQualificationVisit.label27}</li>
                <li>{duringTheSiteQualificationVisit.label28}</li>
                <li> {duringTheSiteQualificationVisit.label29}</li>
                <li>{duringTheSiteQualificationVisit.label30} </li>
                <li> {duringTheSiteQualificationVisit.label31}</li>
              </ul>
            </Grid>
          </Grid>

          <Grid item md={12}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{duringTheSiteQualificationVisit.label32}</Typography>}
                  value={sqChecklistPILFormData.sq_over_other_info}
                  name="sq_over_other_info"
                  checked={sqChecklistPILFormData.sq_over_other_info ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={10} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_over_comment"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_over_comment || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!isDisable || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                {isDisable ? (
                  <Button
                    disabled={!isSaveBtnEnable || !checkedInStartDate}
                    onClick={() => {
                      durationSiteVisitUpdate(sqChecklistPILFormData);
                      setIsSaveBtnEnable(false);
                      setIsNavigateToPannel(true);
                    }}
                    variant="text"
                  >
                    SAVE
                  </Button>
                ) : (
                  ''
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default DuringSiteQulificationVisit;
